'use strict';

// utility class
import ApplyClass from '../Utils/ApplyClass';

import Form from '../Controller/Form';

import Validate from '../View/Form/Validate';
import Submit from '../View/Form/Submit';
import ZenkakuToHankaku from '../View/Form/ZenkakuToHankaku';
import HasCounter from '../View/Form/HasCounter';
import DeleteItem from '../View/Form/DeleteItem';
import ChangeDate from '../View/Form/ChangeDate';
import ChangeSelect from '../View/Form/ChangeSelect';
import Agree from '../View/Form/Agree';
import Agree2 from '../View/Form/Agree2';

import InitialModal from '../View/Form/InitialModal';
import SetComplete from '../View/Form/SetComplete';
import RegistPassport from '../View/Form/RegistPassport';
import EditPassport from '../View/Form/EditPassport';
import WithdrawalPassport from '../View/Form/WithdrawalPassport';
import DeletePassport from '../View/Form/DeletePassport';


//管理画面
import CheckGenreNum from '../View/Form/CheckGenreNum';
import ToggleCheck from '../View/Form/ToggleCheck';
import UploadPhoto from '../View/Form/UploadPhoto';
import DeletePhoto from '../View/Form/DeletePhoto';
import CheckAll from '../View/Form/CheckAll';

$(() => {
	const FormController = new Form();
	// validate
	$('.validate').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Validate, $e, [$e, FormController]);
	});
	// 全角→半角変換
	$('.zen2han').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ZenkakuToHankaku, $e, [$e, FormController]);
	});
	// カウンター
	$('.has-counter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(HasCounter, $e, [$e, FormController]);
	});
	// submit
	$('[type=submit][data-form]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Submit, $e, [$e, FormController]);
	});
	// アイテム削除
	$('.btn-delete-item').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeleteItem, $e, [$e, FormController]);
	});
	// 日付変更
	$('.date-change').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDate, $e, [$e, FormController]);
	});
	// セレクトボックス変更
	$('.select-change').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeSelect, $e, [$e, FormController]);
	});
	// 規約に同意
	$('#agree').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Agree, $e, [$e, FormController]);
	});
    // 規約に同意
    $('#agree2').each((idx, e) => {
        const $e = $(e);
        ApplyClass.apply(Agree2, $e, [$e, FormController]);
    });
	// 初期モーダル
	$('#initialModal').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(InitialModal, $e, [$e, FormController]);
	});
	// 初期モーダル終了
	$('.anchor--complete-initial').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SetComplete, $e, [$e, FormController]);
	});
	// パスポート登録
	$('.anchor--passport').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(RegistPassport, $e, [$e, FormController]);
	});
	// パスポート編集
	$('.edit-passport').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(EditPassport, $e, [$e, FormController]);
	});
	// パスポート登録解除
	$('.anchor--withdrawal').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(WithdrawalPassport, $e, [$e, FormController]);
	});
	// パスポート削除
	$('#delete-passport').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeletePassport, $e, [$e, FormController]);
	});

	/************** 管理画面 ****************/
	// ジャンル数確認
    $('.genre-num').each((idx, e) => {
        const $e = $(e);
        ApplyClass.apply(CheckGenreNum, $e, [$e, FormController]);
    });
    // ジャンル数確認
    $('.toggle-check').each((idx, e) => {
        const $e = $(e);
        ApplyClass.apply(ToggleCheck, $e, [$e, FormController]);
    });
	//  写真アップロード
	$('.file-upload').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(UploadPhoto, $e, [$e, FormController]);
	});
	//  写真削除
	$('.btn--delete-photo').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeletePhoto, $e, [$e, FormController]);
	});
    // 一括承認
	$('.check-all').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckAll, $e, [$e, FormController]);
	});
});
